import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Image } from 'react-bootstrap';
// import Background from 'components/common/Background';
import Avatar from 'components/common/Avatar';
// import classNames from 'classnames';
import { getFileAsUint8Array } from 'nursd-dashboard/utils/function';
import { uploadFile } from 'nursd-dashboard/utils/AWSHelper';
import { v4 as uuidv4 } from 'uuid';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import UploadImage from './settings/UploadImage';

const ProfileBannerHeader = ({
  avatar,
  // coverSrc,
  // className,
  user,
  updateProfileImage
}) => {
  const [file, setFile] = useState([]);
  const { authToken } = useAuth();

  const handleConvert = async file => {
    if (file && file[0]) {
      const uint8Array = await getFileAsUint8Array(file[0]);
      return uint8Array; // Do something with the Uint8Array
    }
  };
  const upload = async file => {
    // const blob = await getBlob(fileDoc);
    // const buffer = await blobToUint8Array(blob);
    const buffer = await handleConvert(file);

    let name = `${user?.uniqueId}/${uuidv4()}.png`;
    // console.log(buffer, name)
    const key = await uploadFile(authToken, name, buffer, '');
    updateProfileImage(key?.key);
  };

  return (
    <Card.Header>
      {/* <Background image={coverSrc} className="rounded-3 rounded-bottom-0" /> */}
      {updateProfileImage ? (
        <UploadImage
          file={file}
          setFile={setFile}
          upload={upload}
          user={user}
        />
      ) : user?.profileImage ? (
        <Image
          thumbnail
          fluid
          roundedCircle
          className="mb-3 shadow-sm"
          src={user?.profileImage}
          width={100}
          height={100}
        />
      ) : (
        <Avatar size="5xl" name={avatar} className="me-2" />
      )}
    </Card.Header>
  );
};

const ProfileBannerBody = ({ children }) => {
  return <Card.Body>{children}</Card.Body>;
};

const ProfileBanner = ({ children }) => {
  return <Card className="mb-3">{children}</Card>;
};

ProfileBanner.Header = ProfileBannerHeader;
ProfileBanner.Body = ProfileBannerBody;

ProfileBannerHeader.propTypes = {
  avatar: PropTypes.string.isRequired,
  coverSrc: PropTypes.string.isRequired,
  className: PropTypes.string,
  user: PropTypes.any,
  updateProfileImage: PropTypes.any
};

ProfileBannerBody.propTypes = {
  children: PropTypes.node.isRequired
};

ProfileBanner.propTypes = {
  children: PropTypes.node.isRequired
};

export default ProfileBanner;
